import { createContext, useContext } from "react";

/** Context to indicate whether we are in an admin view. Set in the admin root component. */
export const InAdminContext = createContext<boolean>(false);

export function useInAdmin(): boolean {
    return useContext(InAdminContext);
}

/** @returns if this URL path belongs to an admin route */
export function isAdminPath(path: string) {
    return path.startsWith("/admin/");
}
